/**
 * Die häufigen Fragen — nicht ausgedacht, sondern aus der Search Console.
 *
 * Jede dieser Fragen wird tatsächlich gesucht; die meisten stehen bereits auf
 * Position 6 bis 9, ohne dass die Seite sie beantwortet. Die Zahlen in den
 * Antworten kommen aus dem Katalog, damit sie nicht veralten.
 */
import { euro } from "./preisAnalyse.js";

export function startseiteFaq(analyse, merkmale) {
  if (!analyse) return [];

  const { gesamt, nachDruck, nachLieferung, umbuchung } = analyse;
  const kontingent = nachDruck.find((g) => g.label.includes("Kontingent"));
  const versand = nachLieferung.find((g) => g.label.includes("Versand"));

  return [
    {
      question: "Was kostet eine Fotobox für eine Hochzeit?",
      answer: `Für eine Hochzeit mit 80 bis 120 Gästen ist ein Paket mit Drucker und mindestens 200 Bildern üblich. Solche Pakete liegen im Vergleich im Median bei ${euro(kontingent ? kontingent.median : gesamt.median)} €. Wer viel drucken lassen möchte, fährt mit einer Druck-Flatrate oft besser — die gibt es bei ${merkmale?.mitFlatrate ?? 0} der ${analyse.anzahlBoxen} Fotoboxen.`,
    },
    {
      question: "Lohnt sich eine Druck-Flatrate?",
      answer:
        "Ab etwa 80 Gästen ja. Als Faustregel gilt: zwei bis drei Ausdrucke pro Gast. Bei 100 Gästen sind das bis zu 300 Bilder — ein festes Kontingent ist dann meist aufgebraucht, bevor der Abend vorbei ist. Bei kleineren Feiern reicht ein Kontingent.",
    },
    {
      question: "Wie viele Bilder druckt eine Fotobox pro Stunde?",
      answer: `Ein Ausdruck braucht im Median ${merkmale?.druckzeit ?? 12} Sekunden. Der Engpass ist selten der Drucker, sondern die Zeit, die Gäste vor der Box verbringen — realistisch sind 40 bis 60 Bilder pro Stunde.`,
    },
    {
      question: "Wie lange vorher sollte ich eine Fotobox buchen?",
      answer:
        "Für Samstage in der Hochzeitssaison zwischen Mai und September: zwei bis drei Monate vorher. Unter der Woche und außerhalb der Saison reichen oft ein bis zwei Wochen. Bei Versandboxen ist zusätzlich die Lieferzeit einzuplanen — im Vergleich siehst du zu jedem Termin, ob sie noch reicht.",
    },
    {
      question: "Wie lange dauert der Aufbau einer Fotobox?",
      answer:
        "Bei einer Versandbox 10 bis 15 Minuten: Stativ aufstellen, Kamera aufsetzen, Strom anschließen, fertig. Eine Anleitung liegt bei. Anbieter vor Ort bauen selbst auf, meist am Tag der Feier oder am Vortag.",
    },
    {
      question: "Braucht eine Fotobox einen eigenen Stromanschluss?",
      answer:
        "Eine normale Steckdose in der Nähe genügt. Kamera, Licht und Drucker hängen an einer Mehrfachsteckdose; ein Verlängerungskabel gehört bei den meisten Anbietern zum Paket.",
    },
    {
      question: "Was ist der Unterschied zwischen Fotobox und Fotoautomat?",
      answer:
        "Keiner — die Begriffe meinen dasselbe Gerät. Photobooth ist das englische Original, Fotoautomat erinnert an die Passbildkabine, Fotokiste ist die eingedeutschte Variante. Auch zwischen mieten, leihen und ausleihen gibt es keinen Unterschied. Was sich wirklich unterscheidet, ist die Bauform: klassische Box auf Stativ, Spiegel-Fotobox, geschlossene Kabine oder Fotobus.",
    },
    {
      question: "Kann ich umbuchen, wenn sich der Termin verschiebt?",
      answer: `Bei ${umbuchung.kostenlos} von ${umbuchung.gesamt} Fotoboxen ist die Umbuchung kostenlos, meist bis wenige Tage vor dem Termin. Bei den übrigen kann eine Gebühr anfallen — die Bedingung steht auf jeder Karte im Vergleich.`,
    },
    {
      question: "Was kostet die Lieferung?",
      answer: `Bei allen ${analyse.versand.gesamt} Versand-Fotoboxen im Vergleich ist der Versand kostenlos, hin und zurück. Bei regionalen Anbietern hängt die Anfahrt von der Entfernung ab; wir rechnen sie für deine Postleitzahl aus, bevor du anfragst. Versandpakete liegen im Median bei ${euro(versand ? versand.median : gesamt.median)} €.`,
    },
    {
      question: "Brauche ich jemanden, der die Fotobox betreut?",
      answer:
        "Bei privaten Feiern selten — die Gäste bedienen sie selbst, und die Box läuft den ganzen Abend durch. Bei Firmenveranstaltungen mit vielen Gästen in kurzer Zeit oder bei engen Zeitplänen ist ein Anbieter vor Ort sinnvoll, der die Box im Blick behält und Papier nachlegt.",
    },
  ];
}
